<template>
  <div class="d-flex px-2" style="min-width: 0; flex:1 1 0">
    <v-carousel
      :height="formatHeight"
      hide-delimiters
      :cycle="true"
      hide-delimiter-background
      :show-arrows="false"
      :interval="6000"
    >
      <v-carousel-item
        v-for="(slide, i) in newsSlides"
        :key="i"
      >
        <div class="py-1 px-1 d-flex flex-column" @click="openNews(slide.url)">
          <div class="d-flex">
            <span
              class="text-body-2 text--primary d-inline-block text-truncate"
            >
              {{ slide.source }}
            </span>
            <v-spacer></v-spacer>
            <span class="text-caption text--disabled text-no-wrap">
              {{ formatFromCustomString(slide.time_published, 'time') }}
            </span>
          </div>
          <div
            class="text-body-1 text--secondary"
          >
          {{ truncateFormatText(slide) }}
          </div>
        </div>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
import { mapState } from "pinia"
import { useSettingsStore } from "@/store/index"
import { useFxMarketStore } from "@/store/toolbarStore";
import * as utils from "@/utils/utils.js"

export default {
    data() {
        return {
            reveal: false,
            fontSize: useSettingsStore().fontsize,
        }
    },
    computed: {
        ...mapState(useFxMarketStore, [
            "getFxMarketNews",
        ]),
        formatHeight(){
            return this.fontSize === 'LG' ?  120 : 80
        },
        newsSlides() {
            if (!this.getFxMarketNews) {
                return []
            }

            const flattenedSlides = this.getFxMarketNews.flatMap(slideGroup =>
                Object.values(slideGroup.feed).filter(slide => {
                    const titleOrContent = (slide.title).toLowerCase() + (slide.summary).toLowerCase()
                    return !titleOrContent.includes('bitcoin') && !titleOrContent.includes('crypto')
                })
            )

            const filterByCurrency = (currencyCode) => {
                return flattenedSlides.filter(slide => {
                    if (slide.ticker_sentiment) {
                        return slide.ticker_sentiment.some(tickerData => tickerData.ticker === `FOREX:${currencyCode}`)
                    }
                    return false
                })
            }

            let forexData = filterByCurrency('BRL')
            if (forexData.length < 4) {
                forexData = forexData.concat(filterByCurrency('USD').slice(0, 4 - forexData.length))
            }
            if (forexData.length < 4) {
                forexData = forexData.concat(filterByCurrency('EUR').slice(0, 4 - forexData.length))
            }
            if (forexData.length < 4) {
                forexData = forexData.concat(filterByCurrency('JPY').slice(0, 4 - forexData.length))
            }

            forexData = forexData.slice(0, 4)

            forexData.sort((a, b) => {
                const dateA = new Date(
                    `${a.time_published.slice(0, 4)}-${a.time_published.slice(4, 6)}-${a.time_published.slice(6, 8)}T${a.time_published.slice(9, 11)}:${a.time_published.slice(11, 13)}`
                )
                const dateB = new Date(
                    `${b.time_published.slice(0, 4)}-${b.time_published.slice(4, 6)}-${b.time_published.slice(6, 8)}T${b.time_published.slice(9, 11)}:${b.time_published.slice(11, 13)}`
                )
                return dateB - dateA
            })

            return forexData
        },
    },
    methods: {
        truncateFormatText(slide) {
            if (this.fontSize === 'SM')
            {
                return slide.title.slice(0,65).trim().concat("...")
            }
            else if(this.fontSize === 'MD')
            {
                return slide.title.slice(0,55).trim().concat("...")
            }

            return slide.title.slice(0,20).trim().concat("...")

        },
        formatFromCustomString(dateString, formatType) {
            return utils.formatFromCustomString(dateString, formatType)
        },
        openNews(url) {
            window.open(url, "_blank")
        }
    }
}
</script>

<style scoped>
.v-card--reveal {
    bottom: 0;
    opacity: 1 !important;
    position: absolute;
    width: 10
}

::v-deep .text--secondary {
    line-height: 1rem !important;
}
</style>